import { SET_VALIDATION_DATA, SET_VALIDATION_DATA_LOADING } from './types'

const defaultState = {
  isLoading: false,
  data: {
    selectedChargers: 0,
    availableForUpdate: 0,
    selectedChargerIds: []
  }
}

export default function configUpdateReducer (state = defaultState, action) {
  switch (action.type) {
    case SET_VALIDATION_DATA_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }

    case SET_VALIDATION_DATA: {
      return {
        ...state,
        data: action.payload,
        isLoading: false
      }
    }

    default:
      return state
  }
}
